import { ref } from "vue";
import { defineStore } from "pinia";

// A store, rather than a dialog, because a guard cannot wait for a click.
export const useNavigationPromptStore = defineStore("navigationPrompt", () => {
    const visible = ref(false);

    let answer: ((discard: boolean) => void) | null = null;

    const settle = (discard: boolean) => {
        const pending = answer;
        answer = null;
        pending?.(discard);
    };

    const confirm = (): Promise<boolean> => {
        // Browser back can start a second navigation while the dialog is up.
        // The first one loses its buttons, so answering it here is what keeps
        // that navigation from hanging forever.
        settle(false);

        visible.value = true;

        return new Promise((resolve) => {
            answer = resolve;
        });
    };

    const discard = () => {
        visible.value = false;
        settle(true);
    };

    const keep = () => {
        visible.value = false;
        settle(false);
    };

    return { visible, confirm, discard, keep };
});
